"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FC, PropsWithChildren, useContext } from "react";
import { CardButtonContext, getCardButtonColors } from "./utilities";
const CardButtonTitle: FC<PropsWithChildren & {
  className?: string;
}> = t0 => {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  const {
    variant,
    size
  } = useContext(CardButtonContext);
  if (!children) {
    return null;
  }
  let t1;
  if ($[0] !== className || $[1] !== size || $[2] !== variant) {
    const textColor = getCardButtonColors("title", variant);
    t1 = clsx(textColor, {
      "text-app-h2": size === "sm",
      "text-h2": size === "lg"
    }, className);
    $[0] = className;
    $[1] = size;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default CardButtonTitle;